<div class="inspection-report">
  @for (section of sections; track $index) {
    <section class="report-section">
      @if (section.label) {
        <h4 class="report-section__heading">{{ section.label }}</h4>
      }

      @for (group of section.groups; track $index) {
        <div class="report-group">
          @if (group.label) {
            <h5 class="report-group__heading">{{ group.label }}</h5>
          }

          @for (field of group.fields; track field.id || $index) {
            <div class="report-field">
              <div class="report-field__label">
                {{ field.label }}
                @if (field.required) {
                  <span class="report-field__required" aria-hidden="true">*</span>
                }
              </div>

              @if (field.hint) {
                <div class="report-field__hint">{{ field.hint }}</div>
              }

              <div class="report-field__value">
                @if (isPhoto(field)) {
                  <ysh-gallery [images]="fieldPhotos(field)"/>
                }
                @else if (isMultiSelect(field)) {
                  <ul class="report-field__chips">
                    @for (item of asList(field); track $index) {
                      <li class="report-field__chip">{{ item }}</li>
                    }
                  </ul>
                }
                @else if (isDataUrl(field)) {
                  <img class="report-field__image" [src]="displayValue(field)" [alt]="field.label">
                }
                @else if (isStatus(field)) {
                  <ysh-badge [value]="displayValue(field)" theme="status"/>
                }
                @else {
                  <span class="report-field__text">{{ displayValue(field) }}</span>
                }
              </div>
            </div>
          }
        </div>
      }
    </section>
  }
</div>
